import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzNativeDateAdapter } from 'ng-zorro-antd/core/time';
import { NzModalService } from 'ng-zorro-antd/modal';
import { providePayments } from '@dlap-ui/shared';
import {
  API_BASE_URL,
  authInterceptor,
  errorInterceptor,
  PORTAL_NAME,
  refreshTokenInterceptor,
} from '@dlap-ui/core';
import { environment } from '../environments/environment';
import {
  AppstoreOutline,
  ArrowRightOutline,
  BankOutline,
  BranchesOutline,
  CalendarOutline,
  CheckCircleOutline,
  CheckOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseOutline,
  ClusterOutline,
  CustomerServiceOutline,
  DeleteOutline,
  DollarOutline,
  DownOutline,
  EditOutline,
  EnvironmentOutline,
  ExclamationCircleOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileOutline,
  FileProtectOutline,
  FileSearchOutline,
  FilterOutline,
  GiftOutline,
  HomeOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleOutline,
  DownloadOutline,
  KeyOutline,
  LockOutline,
  LoginOutline,
  SplitCellsOutline,
  LogoutOutline,
  FileSyncOutline,
  PartitionOutline,
  ProductOutline,
  MailOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  PlayCircleOutline,
  PlusOutline,
  RightOutline,
  SafetyCertificateOutline,
  SafetyOutline,
  SearchOutline,
  StopOutline,
  SwapOutline,
  SyncOutline,
  TeamOutline,
  ThunderboltOutline,
  TrophyOutline,
  UndoOutline,
  UserOutline,
  WalletOutline,
  WarningOutline,
  FileDoneOutline,
  UserAddOutline,
} from '@ant-design/icons-angular/icons';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, refreshTokenInterceptor])),
    provideRouter(appRoutes),
    provideNzI18n(en_US),
    provideNzNativeDateAdapter(),
    NzModalService,
    providePayments({
      apiUrl: environment.server,
      frontendUrl: window.location.origin + '/',
      appName: 'Deeds',
      production: environment.production,
      iveriApplicationId: environment.payment.iveriApplicationId,
      iveriGateway: environment.payment.iveriGateway,
      iveriReturnUrl: environment.payment.iveriReturnUrl,
      zimswitchGateway: environment.payment.zimswitchGateway,
      paymentRedirectUrl: environment.payment.paymentRedirectUrl,
      userStorageKey: 'auth_user',
    }),
    { provide: API_BASE_URL, useValue: environment.server },
    { provide: PORTAL_NAME, useValue: 'LAW_FIRM' },
    provideNzIcons([
      MailOutline,
      LockOutline,
      KeyOutline,
      EyeOutline,
      EyeInvisibleOutline,
      MenuOutline,
      CloseOutline,
      RightOutline,
      DownOutline,
      UserOutline,
      LoginOutline,
      SyncOutline,
      AppstoreOutline,
      CalendarOutline,
      DeleteOutline,
      DownloadOutline,
      DollarOutline,
      EditOutline,
      FileDoneOutline,
      ExclamationCircleOutline,
      FileOutline,
      FilterOutline,
      SplitCellsOutline,
      IdcardOutline,
      InboxOutline,
      LogoutOutline,
      MenuFoldOutline,
      MenuUnfoldOutline,
      PlusOutline,
      SearchOutline,
      TeamOutline,
      UndoOutline,
      WalletOutline,
      WarningOutline,
      BankOutline,
      BranchesOutline,
      CloseCircleOutline,
      ClusterOutline,
      EnvironmentOutline,
      FileProtectOutline,
      FileSearchOutline,
      FileSyncOutline,
      PartitionOutline,
      ProductOutline,
      FileProtectOutline,
      GiftOutline,
      HomeOutline,
      SafetyCertificateOutline,
      SwapOutline,
      InfoCircleOutline,
      CheckOutline,
      CheckCircleOutline,
      PlayCircleOutline,
      StopOutline,
      SafetyOutline,
      ThunderboltOutline,
      CustomerServiceOutline,
      ArrowRightOutline,
      ClockCircleOutline,
      TrophyOutline,
      UserAddOutline
    ]),
  ],
};
